<template>
  <div>
    <div class="sidebar-container" v-if="permits.items && permits.items.length > 0">
      <template v-for="permit in permits.items">
        <router-link
          :to="isMobileScreen ? {name: 'edit-user-permit', params: { id: permit.id }} : { name: 'user-permit', params: { id: permit.id } }"
          :key="permit.id"
          class="permit-block"
          v-show="isPermitExpired(permit) ? checkedHidePermits === true ? false : true : true"
        >
          <div :class="{ 'permit-header': isDuplicatedPermit(permit) }">
            <div class="permit-block__zone">
              <div class="permit-block__product" v-if="permit.productName">
                <span class="icon-product"></span>
                <span>{{ permit.productName }}</span>
              </div>
              <div v-if="permit.address">
                <span class="fa fa-map-marker icon-zone"></span>
                <span>{{ permit.address }}</span>
              </div>
            </div>
            <div class="icon-container" v-if="isDuplicatedPermit(permit)">
              <div class="permit-icon-container"><img src="~assets/duplicate-permit.svg" /></div>
            </div>
          </div>
          <div class="permit-block__identifiers">
            <div class="permit-block__identifiers__identity permit-plate" v-if="permit.vehicleReg">
              <div class="icon icon--car"></div>
              <p
                :class="{ 'smaller-font': permit.vehicleReg && permit.vehicleReg.length > 6 }"
              >{{ permit.vehicleReg }}</p>
              <p class="permit-plate__spot" v-if="permit.parkingSpotNumber"> {{ permit.parkingSpotNumber }}</p>
            </div>
            <div
              class="permit-block__identifiers__identity permit-card permit-card__small"
              v-if="permit.parkingCardNr"
            >
              <div class="permit-card__number">{{ permit.parkingCardNr }}</div>
            </div>
            <div
              class="permit-block__identifiers__identity no-identity"
              v-if="!permit.vehicleReg && !permit.parkingCardNr"
            >
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              {{ $t('end_user.permit_needs_identity') }}
            </div>
          </div>
          <div
            class="permit-card-validity"
            v-if="!isPermitExpired(permit) && permitValidityPeriod(permit).length > 0"
          >{{ permitValidityPeriod(permit) }}</div>
          <div
            class="permit-card-expired"
            v-if="isPermitExpired(permit)"
          >{{ $t('end_user.permit_expired', {expirationDate: permit.expirationDate}) }}</div>
          <div
            v-if="permit.validFromDate && !permit.expirationDate && !permit.permitUpdatedAt"
            class="permit-block__updatedat"
          >{{ $t('end_user.permit_validity_from', {from: permit.validFromDate}) }}</div>
          <div
            v-if="permit.permitUpdatedAt && !permit.expirationDate"
            class="permit-block__updatedat"
          >{{ $t('end_user.vehicle_updated_at', {from: permit.permitUpdatedAt}) }}</div>
        </router-link>
      </template>
    </div>
    <div class="no-permits" v-if="(!permits.items || permits.items.length === 0)">
      <h1>{{ $t('end_user.no_permits') }}</h1>
    </div>
  </div>
</template>

<script type="text/javascript">
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      activePermit: null,
      isMobileScreen: false,
    };
  },
  props: {
    checkedHidePermits: {
      type: Boolean,
      default: false,
    },
  },
  computed: mapGetters({
    permits: 'landlord/permits/permits',
    user: 'user/user/user',
  }),
  watch: {
    $route: 'selectPermit',
  },
  methods: {
    selectPermit() {
      if (this.$route.params.id) {
        this.activePermit = parseInt(this.$route.params.id, 10);
      }
    },
    navigateToEditViewPermit(event, permitId) {
      event.preventDefault();
      this.$router.push({ name: 'edit-user-permit', params: { id: permitId } });
    },
    isDuplicatedPermit(permitToSearch) {
      const filteredPermits = this.permits.items.filter(permit => permit.vehicleReg === permitToSearch.vehicleReg && permit.productName === permitToSearch.productName);
      return filteredPermits.length > 1;
    },
    setIsMobileScreen() {
      if (window.innerWidth > 760) {
        this.isMobileScreen = false;
      } else {
        this.isMobileScreen = true;
      }
    },
    permitValidityPeriod(permit) {
      if (permit.validFromDate && permit.expirationDate) {
        return this.$t('end_user.permit_validity', { from: permit.validFromDate, to: permit.expirationDate });
      }
      return '';
    },
    isPermitExpired(permit) {
      if (!permit.expirationDate) {
        return false;
      }

      return moment().isAfter(moment(permit.expirationDate, 'DD.MM.YYYY'), 'day');
    },
    formatDate(momentDate) {
      return moment(momentDate, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },
  },
  created() {
    this.selectPermit();
    window.addEventListener('resize', this.setIsMobileScreen);
    this.setIsMobileScreen();
  },
};

</script>

<style media="screen" scoped lang="scss">
@import "~styles/app.scss";
@import "~styles/_animations.scss";
@import "~styles/blocks/permit.scss";

.permit-header {
  display: flex;
  gap: 8px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #00D1B2;
  border-radius: 5px;
  flex-basis: 15%;
}

.permit-icon-container {
  display: flex;
}

.no-permits {
  background: var(--brand-red);
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  color: var(--white);
  padding: 20px;
  flex-direction: column;

  @media screen and (max-width: 1115px) {
    margin: 0 0 45px 0;
  }
}

.sidebar-container {
  height: 100%;
  display: inline-block;
  margin-right: -20px;

  @media screen and (max-width: 520px) {
    width: 100%;
  }

  @media screen and (max-width: 760px) {
    width: 100%;
  }

  .permit-block {
    margin: 0 20px 10px 0;

    &.active {
      width: 320px;
      margin-right: 0;
      padding-right: 20px;
    }
  }
}
.icon-zone {
  margin: 0 5px 0 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/end-user/Sidebar.vue